import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import {
    LowerSection, LowerSectionText, ButtonContainer,
    DangerFilledButton, DefaultButton, ButtonSpacer,
} from './Components';

import UpperSectionAlert from './UpperSection/Alert';

export default function UnsavedDialogContent(props) {
    const { onConfirm, onDismiss } = props;

    return (
        <div>
            <UpperSectionAlert>
                There are unsaved changes on this page
            </UpperSectionAlert>

            <LowerSection>
                <LowerSectionText>
                    Unsaved changes will be lost if you leave this page
                </LowerSectionText>
                <ButtonContainer>
                    <DangerFilledButton
                        data-action="confirm"
                        onClick={onConfirm}
                    >
                        OK
                    </DangerFilledButton>
                    <ButtonSpacer />
                    <DefaultButton
                        data-action="dismiss"
                        onClick={onDismiss}
                    >
                        Cancel
                    </DefaultButton>
                </ButtonContainer>
            </LowerSection>
        </div>
    );
}

UnsavedDialogContent.displayName = displayName('Dialog/UnsavedDialogContent');

UnsavedDialogContent.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
};
